import get from 'lodash/get';
import { getContentfulImage } from 'UI/components/Illustration/utils/helpers';
import { getImage } from 'utils/helper';
import { useRef, useState } from 'react';
import { videoFormats } from './helpers';

export default ({
  asset,
  className,
  isStatic,
  transparent,
  loaderParams,
  displayParams,
  ...rest
}) => {
  const ref = useRef(null);
  const { file: { contentType } } = get(asset, 'fields', {});
  const isVideo = videoFormats(contentType);
  const { url, alt } = getImage(asset);

  const imageProps = {
    alt,
    src: displayParams ? getContentfulImage({ src: url, ...displayParams }) : url,
    layout: 'fill',
    lazyBoundary: '700px',
    unoptimized: true,
    loader: isStatic
      ? ({ src }) => src
      : (args) => getContentfulImage({ transparent, ...args, ...loaderParams }),
    ...rest,
  };

  return {
    ref,
    url,
    isVideo,
    className,
    imageProps,
    ...rest,
  };
};
